import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { BranchResponse } from '../models/branch-response.model';
import { BranchesRepository } from '../repositories/branches.repository';
import { BranchParams } from '../models/branch.model';

export class FindBranchesUseCase
    implements UseCase<BranchParams, BranchResponse>
{
    constructor(private readonly repository: BranchesRepository) {}

    execute(searchTerm: BranchParams): Observable<BranchResponse> {
        return this.repository.findBranches(searchTerm);
    }
}
